import { render, staticRenderFns } from "./BorderBlock.vue?vue&type=template&id=5da0801f&scoped=true"
var script = {}
import style0 from "./BorderBlock.vue?vue&type=style&index=0&id=5da0801f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5da0801f",
  null
  
)

export default component.exports